import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AwardsModule } from '@features/awards/awards.module';
import { CancelApplicationModule } from '@features/cancel-application/cancel-application.module';
import { CopyApplicationModule } from '@features/copy-application/copy-application.module';
import { FormRendererModule } from '@features/forms/form-renderer-module';
import { MyApplicationsModule } from '@features/my-applications/my-applications.module';
import { OrganizationSearchModule } from '@features/organization-search/organization-search.module';
import { SignatureModule } from '@yourcause/common/signature';
import { ApplicationManagerModule } from '../application-manager/application-manager.module';
import { CollaborationModule } from '../collaboration/collaboration.module';
import { NominationsModule } from '../nominations/nominations.module';
import { ApplicationAwardsModalComponent } from './application-awards-modal/application-awards-modal.component';
import { ApplyPageComponent } from './apply-page/apply-page.component';
import { NoProgramsAvailableModalComponent } from './no-programs-available-modal/no-programs-available-modal.component';
import { PublicProgramPageComponent } from './public-program-page/public-program-page.component';


@NgModule({
  imports: [
    GCCoreModule,
    ApplicationManagerModule,
    CollaborationModule,
    NominationsModule,
    MyApplicationsModule,
    FormRendererModule,
    CancelApplicationModule,
    SignatureModule,
    AwardsModule,
    CopyApplicationModule,
    OrganizationSearchModule
  ],
  declarations: [
    ApplyPageComponent,
    PublicProgramPageComponent,
    NoProgramsAvailableModalComponent,
    ApplicationAwardsModalComponent
  ],
  exports: [
    ApplyPageComponent,
    PublicProgramPageComponent
  ]
})
export class ApplyModule { }
